<template>
  <div class="artifact-version-container">
    <a-row :gutter="12" class="main-layout">
      <!-- 左侧版本列表 -->
      <a-col :span="6" class="left-panel">
        <div class="container">
          <artifact-version-list :artifact-id="artifactId" :selected-version-id="selectedVersionId" @select-version="handleSelectVersion" />
        </div>
      </a-col>

      <!-- 右侧版本详情 -->
      <a-col :span="18" class="right-panel">
        <div class="container">
          <artifact-version-detail :version-id="selectedVersionId" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import ArtifactVersionList from '@/pages/project/service/components/ArtifactVersionList';
import ArtifactVersionDetail from '@/pages/project/service/components/ArtifactVersionDetail';

export default {
  name: 'ArtifactVersion',
  components: {
    ArtifactVersionList,
    ArtifactVersionDetail
  },
  data() {
    return {
      artifactId: this.$route.query.artifactId || null,
      selectedVersionId: null
    };
  },
  methods: {
    handleSelectVersion(versionId) {
      this.selectedVersionId = versionId;
    }
  }
};
</script>

<style lang="less" scoped>
.artifact-version-container {
  height: 100%;
  padding: 12px;
  background-color: #fafafa;

  .main-layout {
    height: 100%;

    .left-panel,
    .right-panel {
      height: 100%;

      .container {
        border-radius: 8px;
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        height: 100%;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .artifact-version-container {
    .main-layout {
      .left-panel,
      .right-panel {
        .ant-col {
          width: 100% !important;
          margin-bottom: 16px;
        }
      }
    }
  }
}
</style>
